export default {
  copy: [{
    selector: 'document',
    texts: ['你都复制了些什么呀，转载要记得加上出处哦！']
  }],
  visibilitychange: [{
    selector: 'document',
    texts: ['Hower Or Click Me']
  }],
  mouseover: [{
    selector: '.vue-live2d-tool .custom-fa-comment',
    texts: ['Click To Get Some Help', 'Ask Me Some questions']
  }, {
    selector: '.vue-live2d-tool .custom-fa-user-circle',
    texts: ['想看看我的朋友们吗？']
  }, {
    selector: '.vue-live2d-tool .custom-fa-street-view',
    texts: ['变装！']
  }, {
    selector: '.vue-live2d-tool .custom-fa-camera-retro',
    texts: ['一起拍照留念？']
  }, {
    selector: '.vue-live2d-tool .custom-fa-info-circle',
    texts: ['Let\'s Get Some Help']
  }, {
    selector: '.vue-live2d-tool .custom-fa-times',
    texts: ['See You Later']
  }]
}
